import React from "react";
 
const Loading = props => {
  return (
<div id="popup1" class="overlay_cus">
    
	<div class="message_popup_loading">
        
    <img  className="loading_logo" src={process.env.PUBLIC_URL + '/images/loader.gif'}   ></img>

		{/* <h3>Processing...</h3>
		<a class="close hand" onClick={props.handle_loading}>&times;</a>

		<div class="text-left mt-2">
		<button type="button" class="btn close_btn size_12 font_fam mt-4" onClick={props.handle_loading}>CLOSE </button>
		</div> */}
	</div>
</div>
  );
};
 
export default Loading;